import {css, StyleSheet} from 'aphrodite';
import PropTypes from 'prop-types';
import React from 'react';

import EntityStore from 'stores/EntityStore';
import getTestProps from 'test/lib/cypress/getTestProps';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

interface ParentLinkProps {
  icon: BenchlingIconName;
  onClickParent: React.MouseEventHandler<HTMLSpanElement>;
  parentName?: React.ReactNode;
  tooltipTitle?: string;
}

/**
 * A link to an object's parent object.
 */
export default function ParentLink({
  icon,
  onClickParent,
  parentName,
  tooltipTitle,
}: ParentLinkProps): JSX.Element {
  // Only show icon for opening containing parent for signed-in users, since signed-out users viewing
  // public items should not have access to listings
  return (
    <div className={css(styles.parentLink)} {...getTestProps({component: 'ParentLink', element: 'root'})}>
      <BenchlingIcon className="u-faded u-mini-spacing-right" icon={icon} />
      {parentName}
      <Tooltip text={tooltipTitle}>
        {EntityStore.currentUser() && (
          <BenchlingIcon className="metadata-icon--folder-parent" icon="upload" onClick={onClickParent} />
        )}
      </Tooltip>
    </div>
  );
}

ParentLink.propTypes = {
  icon: PropTypes.string.isRequired,
  onClickParent: PropTypes.func.isRequired,
  parentName: PropTypes.node,
  tooltipTitle: PropTypes.string,
};

const styles = StyleSheet.create({
  parentLink: {
    alignItems: 'center',
    display: 'inline-flex',
  },
});
